import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DebounceDirective } from "../../directives/debounce.directive";

@Component({
    selector: "app-fuzzy-search-input",
    imports: [FormsModule, DebounceDirective, TranslateModule],
    templateUrl: "./fuzzy-search-input.component.html",
})
export class FuzzySearchInputComponent implements OnInit {
    @Input() placeholder: string;
    @Output() fuzzySearchStart = new EventEmitter<string>();

    searchText: string;

    constructor() {}

    ngOnInit() {}

    filter(value: string) {
        this.searchText = value;
        this.fuzzySearchStart.next(value);
    }

    clearFilter() {
        this.filter("");
    }
}
